import { GridCellProps } from '@progress/kendo-react-grid';
import ProfileCell from '../flyouts/ProfileCell';

function TeamMemberCell({ dataItem }: GridCellProps) {
  return <ProfileCell dataItem={dataItem} selectedTab={0} isTeamMember={true} />;
}

export default TeamMemberCell;
